import { Icon } from '@purpur/library/icon';
import styled from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { HboMaxLogoRound } from './HboMaxLogoRound';

export const HboMaxIconModeDesktop = styled(HboMaxLogoRound)``;
export const HboMaxIconModeMobile = styled(Icon).attrs({ size: 'md' })``;

export const DualMode = styled.span.attrs({ role: 'presentation' })`
    ${purpurMedia('sm')`
        ${HboMaxIconModeDesktop} { display: none; }
        ${HboMaxIconModeMobile} { display: flex; }
    `}
    ${purpurMedia('lg')`
        ${HboMaxIconModeDesktop} { display: flex; }
        ${HboMaxIconModeMobile} { display: none; }
    `}
`;
